import Vue from 'vue'

Vue.filter('newDate', (value) => new Date(value))
